import React from "react";
import * as M from "@material-ui/core";
import { inject, observer } from "mobx-react";

const LanguageSwitcher = ({ store, className, languages = [] }) =>
  languages.length > 1 && (
    <div className={"language-switcher " + className}>
      <M.TextField
        select
        margin="none"
        name="activeLocale"
        value={store.$locale.activeLocale}
        onChange={e => store.$locale.setActiveLocale(e.target.value)}
      >
        {languages.map(key => (
          <M.MenuItem key={key} value={key}>
            {store.$user.sessionUser.isVerifiedMentor
              ? store.$locale.getLanguageLabelForKey(key, "NL")
              : store.$locale.getLanguageLabelForKey(key)}
          </M.MenuItem>
        ))}
      </M.TextField>
    </div>
  );

export default inject("store")(observer(LanguageSwitcher));
